import { useBuilderStore } from '../../store/builderStore';
import { cn } from '@printtat/ui';
import { VariantRow } from "../VariantRow";

export const SizeVariants = () => {
  const availableSizes = useBuilderStore((s) => s.availableSizes);
  const enabledSizes = useBuilderStore((s) => s.enabledSizes);
  const defaultSize = useBuilderStore((s) => s.defaultSize);
  const toggleSize = useBuilderStore((s) => s.toggleSize);
  const setDefaultSize = useBuilderStore((s) => s.setDefaultSize);

  if (availableSizes.length === 0) return null;

  const enabledCount = enabledSizes.length;

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between px-2.5 py-1.5">
        <span className="text-[11px] font-semibold text-[#1a1a1a] tracking-tight">Sizes</span>
        <span className="text-[10px] text-[#aaa]">{enabledCount}/{availableSizes.length}</span>
      </div>
      <div className="flex flex-col pb-1">
        {availableSizes.map((size) => {
          const isEnabled = enabledSizes.includes(size.name);
          const isOutOfStock = !size.hasStock;
          const isDefault = defaultSize === size.name;

          return (
            <VariantRow
              key={size.name}
              isEnabled={isEnabled}
              isOutOfStock={isOutOfStock}
              isDefault={isDefault}
              onToggle={() => toggleSize(size.name)}
              onSetDefault={() => setDefaultSize(size.name)}
            >
              <span
                className={cn(
                  "flex-1 text-[10px] text-[#555] select-none",
                  isOutOfStock && "line-through",
                )}
              >
                {size.name}
              </span>
              {size.additionalPrice > 0 && (
                <span className="text-[9px] text-[#aaa]">+{size.additionalPrice} EGP</span>
              )}
            </VariantRow>
          );
        })}
      </div>
    </div>
  );
};
